<template>
  <div class="statsWrap" :style="`width: ${statsOpen ? '30dvw' : '1dvw'};`">
    <!-- <v-row>
        <v-col cols="auto">
          <Tooltip
            :active="videos.length > 0"
            content="Play Test Case's Video"
            color="indigo"
            left
            transition="slide-x-transition"
          >
            <v-btn
              fab
              color="indigo"
              :disabled="!videos.length"
              :dark="videos.length > 0"
              @click="openVideos"
              x-small
            >
              <v-icon small class="mr-0"> mdi-movie-open-play </v-icon>
            </v-btn>
          </Tooltip>
        </v-col>
        <v-col cols="auto">
          <Tooltip
            :active="stats && !statsOpen"
            content="View Test Case's current Stats"
            color="orange"
            top
            transition="slide-x-transition"
          >
            <v-btn
              fab
              dark
              :outlined="statsOpen"
              color="orange"
              @click="statsOpen = !statsOpen"
              x-small
            >
              <v-icon small class="mr-0"> mdi-chart-areaspline </v-icon>
            </v-btn>
          </Tooltip>
        </v-col>
      </v-row> -->
    <!-- <v-dialog v-model="statsOpen" max-width="50%"> -->
    <v-btn
      fab
      class="exit"
      elevation="0"
      x-small
      @click="statsOpen = !statsOpen"
    >
      <Tooltip
        :active="videos.length"
        :content="statsOpen ? 'Close' : 'Debugger Information'"
        color="orange"
        left
        transition="slide-x-transition"
      >
        <v-icon size="25">
          mdi-{{ statsOpen ? "close-circle" : "chevron-left-circle-outline" }}
        </v-icon>
      </Tooltip>
    </v-btn>
    <v-card elevation="6" rounded :class="`h${height} ma-1`" v-if="statsOpen">
      <!-- <v-card-title class="text-subtitle-1 text-center">
      <h2 class="text--red">
        <v-icon color="indigo" class="mr-0 mb-1"> mdi-chart-areaspline </v-icon>
        Videos & Stats
      </h2>
    </v-card-title>
    <v-divider></v-divider> -->
      <v-card-text :class="`scrollable h${height - 10}`">
        <v-expansion-panels v-model="panel" multiple focusable>
          <v-expansion-panel key="videos">
            <v-expansion-panel-header>
              <Tooltip
                :active="videos.length"
                content="Play Test Case's Videos"
                color="indigo"
                left
                transition="slide-x-transition"
              >
                <v-icon class="mr-0" color="indigo">
                  mdi-movie-open-play
                </v-icon>
                Videos
              </Tooltip>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-carousel
                v-if="videos.length"
                show-arrows-on-hover
                hide-delimiters
                height="auto"
                class="bs mt-3"
              >
                <v-carousel-item
                  v-for="(v, index) in videos"
                  :key="index"
                  contain
                >
                  <VideoPlayer :src="v" />
                </v-carousel-item>
              </v-carousel>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel key="pages">
            <v-expansion-panel-header>
              <Tooltip
                :active="pages.length"
                content="Track Test Case's Pages"
                color="purple"
                left
                transition="slide-x-transition"
              >
                <v-icon color="purple" class="mr-0">
                  mdi-file-chart-check-outline
                </v-icon>
                Pages
              </Tooltip>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-carousel
                v-if="pages.length"
                show-arrows-on-hover
                hide-delimiters
                height="auto"
                class="mt-3"
              >
                <v-carousel-item
                  v-for="(v, index) in pages"
                  :key="index"
                  contain
                >
                  <h3 class="text-wrap text-truncate pa-1">
                    URL: {{ v.url }}
                  </h3>
                  <h4 class="text-wrap text-truncate pa-1">
                    Status:
                    <v-chip v-if="!v.diff" small dark color="green">
                      No Changes
                    </v-chip>
                    <v-chip v-else small dark color="purple lighten-1">
                      Changed
                    </v-chip>
                  </h4>
                  <v-row>
                    <v-col v-if="v.reference">
                      <ImageSlot :source="v.reference" v-if="v.reference" />
                    </v-col>
                    <v-col v-if="!v.dif && v.current">
                      <ImageSlot :source="v.current" v-if="v.current" />
                    </v-col>
                    <v-col v-if="v.dif">
                      <ImageSlot :source="v.diff" v-if="v.dif" />
                    </v-col>
                  </v-row>
                </v-carousel-item>
              </v-carousel>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel key="stats">
            <v-expansion-panel-header>
              <Tooltip
                :active="stats.length"
                content="View Test Case's current Stats"
                color="orange"
                left
                transition="slide-x-transition"
              >
                <v-icon class="mr-0" color="orange">
                  mdi-chart-areaspline
                </v-icon>
                Stats
              </Tooltip>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="my-1">
                <v-col cols="4" class="d-flex align-center">
                  <v-btn
                    depressed
                    width="25"
                    height="25"
                    fab
                    color="indigo lighten-5"
                  >
                    <v-icon small color="indigo"
                      >mdi-information-variant
                    </v-icon>
                  </v-btn>
                  <span class="ml-1 title bold"> General</span>
                </v-col>
                <v-col class="d-flex align-center">
                  <div>
                    <div>
                      <strong class="mr-1">
                        <!-- <v-icon size="16" color="red"> mdi-heart-pulse </v-icon> -->
                        Health:
                      </strong>
                      <HealthIcon
                        small
                        class="d-inline-flex"
                        :health="stats.planStatus"
                      />
                    </div>
                    <div>
                      <strong class="mr-1">
                        <!-- <v-icon size="16" color="teal">mdi-counter</v-icon> -->
                        Version:
                      </strong>
                      {{ stats.version }}
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="my-1">
                <v-col cols="4" class="d-flex align-center">
                  <v-btn
                    depressed
                    width="25"
                    height="25"
                    fab
                    color="orange lighten-5"
                  >
                    <v-icon small color="orange">mdi-timer </v-icon>
                  </v-btn>
                  <span class="ml-1 title bold"> Duration</span>
                </v-col>
                <v-col class="d-flex align-center">
                  <div>
                    <div>
                      <strong class="mr-1"> Current: </strong>
                      {{ timeSymbol(stats.duration) }}
                    </div>
                    <div>
                      <strong class="mr-1"> AVG: </strong>
                      {{ timeSymbol(stats.avgDuration) }}
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="auto" class="d-flex align-center">
                  <v-row>
                    <v-col>
                      <v-btn
                        depressed
                        width="25"
                        height="25"
                        class="mb-1"
                        fab
                        color="blue lighten-5"
                      >
                        <v-icon small color="blue">mdi-test-tube </v-icon>
                      </v-btn>
                      <span class="title bold"> Steps</span>
                      <div>
                        <strong>
                          <v-icon class="mb-1" size="16" color="success">
                            mdi-thumb-up
                          </v-icon>
                          Passed:
                        </strong>
                        {{ stats.passed }}
                      </div>
                      <div>
                        <strong>
                          <v-icon size="16" color="error">
                            mdi-thumb-down
                          </v-icon>
                          Faild:
                        </strong>
                        {{ stats.failed }}
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <ChartWrap :chartData="ratio" col :elevation="0" />
              </v-row>
              <v-divider></v-divider>
              <v-row class="mt-1">
                <v-col
                  ><v-icon small color="purple">mdi-web </v-icon> Browser
                  Version:
                  {{ stats.browserVersion }}
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel key="logs">
            <v-expansion-panel-header>
              <Tooltip
                :active="logs.length"
                content="Play Test Case's Videos"
                color="indigo"
                left
                transition="slide-x-transition"
              >
                <v-icon color=" green">mdi-console</v-icon> Console & Network
                Logs
              </Tooltip>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list dense>
                <v-list-item v-for="(item, i) in logs" :key="i">
                  <v-list-item-icon>
                    <v-icon
                      small
                      :color="item.icon == 'console' ? '#20B2AA' : 'orange'"
                      >mdi-{{ item.icon }}</v-icon
                    >
                  </v-list-item-icon>
                  <v-list-item-content class="text-truncate">
                    <Tooltip
                      :content="item.text"
                      :color="item.color"
                      left
                      transition="slide-x-transition"
                    >
                      <v-list-item-title>
                        {{ truncate(item.text, 100) }}
                      </v-list-item-title>
                    </Tooltip>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
    <!-- </v-dialog> -->
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { any, number } from "vue-types";
import Tooltip from "@/components/Tooltip.vue";
import HealthIcon from "./listTable/HealthIcon.vue";
import { logsIcon, timeFormatter, truncate } from "@/utils/index";
import Theme from "../plugins/vuetify";
import ChartWrap from "./ChartWrap.vue";
import VideoPlayer from "./VideoPlayer.vue";
import moment from "moment";
import { SelectItem } from "@/types";
import ImageSlot from "./ImageSlot.vue";

const { mainGreen, mainRed } = Theme?.userPreset?.theme?.themes?.light || {};

export default Vue.extend({
  components: { Tooltip, HealthIcon, ChartWrap, VideoPlayer, ImageSlot },
  name: "ResultStats",

  data() {
    return {
      statsOpen: true,
      panel: [0],
      colors: {
        info: "light-blue",
        error: "red",
        warning: "orange",
      },
    };
  },
  props: {
    result: any().def({}),
    height: number().def(70),
  },
  computed: {
    stats() {
      // console.log(this.result);
      return this.result?.stats
        ? { ...this.result.stats, version: this.result.version }
        : {};
    },
    videos() {
      return this.result?.videos || [];
    },
    pages() {
      const pages = [];
      for (const page in this.result?.pages) {
        const { diff, reference, current } = this.result?.pages[page];
        pages.push({
          url: page,
          diff,
          reference,
          current,
        });
      }
      console.log(pages);
      return pages;
    },
    logs(): SelectItem[] {
      const logs: SelectItem[] =
        this.result?.logs?.map((l) => this.parseLog(l)) || [];
      return logs;
    },
    rate() {
      const { passed, failed } = this.stats;
      return (+passed / (+passed + failed)) * 100;
    },
    ratio() {
      const { passed, failed } = this.stats;
      const all = passed + failed;
      const precent = (+passed / all) * 100;
      const obj = {
        // title: {
        //   style: {
        //     // color: primaryText,
        //     // align: "bottom",
        //   },
        //   align: "center",
        //   text: "Steps",
        // },
        type: "pie",
        tooltip: {
          pointFormat: "<b>{point.num}/{point.all}</b> {series.name}",
        },
        height: "100%",
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.y:.1f} %",
            },
          },
        },
        series: [
          {
            name: "Steps",
            colorByPoint: true,
            size: "60%",
            innerSize: "70%",
            data: [
              {
                name: "Passed",
                y: precent,
                num: passed,
                all,
              },
              {
                name: "Failed",
                y: 100 - precent,
                num: failed,
                all,
              },
            ],
          },
        ],
        colors: [mainGreen, mainRed],
      };

      return obj;
    },
  },
  methods: {
    timeSymbol: timeFormatter,
    truncate,
    parseLog(item: string): {
      icon: string;
      text: string;
      time: string;
      color: string;
    } {
      const parsed: string[] = item.split(" -> ");
      const time = moment(+parsed[1]).format("HH:mm DD/MM/YY");
      const color = this.colors[parsed[3]] || "green";
      const itemObj = {
        icon: logsIcon[parsed[0]],
        text: parsed[2],
        time,
        color,
      };
      return itemObj;
    },
    openVideos() {
      this.$store.commit("setSlidesOptions", {
        height: "auto",
        //   width: "auto",
      });
      this.$store.commit("setSlides", this.videos);
    },
  },
});
</script>

<style scoped>
.statsWrap {
  position: relative;
}
.exit {
  position: absolute;
  top: -5px;
  left: -10px;
  z-index: 100;
}
h3 {
  font-weight: bold;
}
</style>
